import React, { useContext, useState } from 'react';
import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
import Box from '@iso/components/utility/box';
import Input, {
  InputSearch,
  InputGroup,
  Textarea,
} from '@iso/components/uielements/input';
import IntlMessages from '@iso/components/utility/intlMessages';
import { useEffect } from 'react';
import { DeploymentContext } from '../../../context/deploymentContext';
import { AppContext, ContextProvider } from '../../../context/ContextProvider';
import { Checkbox, Form } from 'antd';

export default function DeleteTask({
  data,
  title,
  section,
  subTitle,
  subTitle2,
  subTitle3,
  onDelete,
  fromEnvironment,
  fromWorkflow,
  setShowDeleteDetails,
  columnId,
  impactedServices
}) {

  const [form] = Form.useForm();

  const [error, setError] = useState({
    status: false,
    msg: ""
  });

  // useEffect(() => {
  //   let inputTag = document.getElementById("inputFocus");
  //   inputTag.focus();
  //   console.log('inside deleteTask.js :', inputTag);
  // }, []);


  const [taskName, setTaskName] = useState('');
  const [deleteSecrets, setDeleteSecrets] = useState(true);
  const [deleteWorkflows, setDeleteWorkflows] = useState(true);
  const { subTab, selectedService } = useContext(DeploymentContext);
  const { setOpenModel } = useContext(AppContext);

  useEffect(() => {
    form.setFieldsValue({
      name: ""
    });
  }, []);

  const handelInputChange = (e) => {
    setTaskName(e.target.value);
    form.setFieldValue("name", e.target.value);
    setError({
      status: false,
      msg: ""
    });
  }

  const handleDelete = async (e) => {
    // console.log("data: ", data);
    if (data.title !== "Delete Project Service") {
      try{
        await form.validateFields();
        if (data.name === taskName) {
          if(["Environment", "Service"].includes(section)) {
            onDelete({...data, isDeleteSecret: deleteSecrets, isDeleteWorkflow: deleteWorkflows});
          }
          else {
            onDelete(data);
          }
        }
      }
      catch(err) {
        console.log("Error in handleDelete: ", err);
      }
    }
    else {
      await form.validateFields();
      onDelete(data);
    }
  }

  return (
    <>
      {console.log('data in delete :', data, subTitle2)}
      {/* {console.log('taskName in delete :', taskName)} */}
      {subTab !== "" && data?.info?.dependent_app_ids?.filter(val => val.service_id !== selectedService).length > 0 && <Box
        title={data.title}
        subtitle={data.subtitle}
        subtitle2={subTitle2}
        style={{ border: "0", paddingBottom: "0" }}
      />}
      {/* {console.log("Delete: ", title)} */}

      <Form
        form={form}
        initialValues={{name: taskName}}
        preserve={false}
        name="dynamic_rule"
      // style={{
      //   width: "100%",
      // }}
      >
        {console.log("title in delete :", data)}
        {data.title !== "Delete Project Service" && <Box
          title={title === "Disconnect this account permanently?" ? title : title !== 'Detete the Atmosly created resources permanently?' && title !== "Destroy this EKS Cluster permanently?" && title !== "Delete Cluster Details" && title !== "Remove this cluster from Atmosly?" && section !== "CredentialsManagement" ? `${(title === "DATA SOURCE" || title === "APPLICATION" || title === "ROLESANDPERMISSIONS" || title === "RBAC Role" || title === "Nodegroup" || title === "Nodepool" || title === "Workspace" || title === "Workspace Resources" ||data.type === "helm" || section === "Environment" || section === "Service" || section === "Project") ? "Delete" : "Destroy"} ${title}` : `${title}`}
          subtitle={subTitle}
          subtitle2={subTitle2}
          style={{ border: "0", paddingTop: "0", padding: (!fromEnvironment && !fromWorkflow) ? "auto" : "0" }}
        >
          {/* checkbox for delete secrets and workflows */}
          {((section === "Environment") || (section === "Service" && !data?.info?.db_type)) && <div style={{ display: "block", marginTop: "10px" }}>
            <Checkbox 
              checked={deleteSecrets}
              onChange={(e) => {
                setDeleteSecrets(e.target.checked);
              }}
              style={{ fontSize: "12px", marginBottom: "10px" }}
            >
              Delete Secrets: <span style={{ fontSize: "12px", color: "#797979" }}>uncheck this if you don't want to delete secrets {section === "Environment" ? `from all services and workflows associated with this ${section.toLowerCase()}` : `from this service and it's workflow.`}</span>
            </Checkbox>
            
            <Checkbox
              checked={deleteWorkflows}
              onChange={(e) => {
                setDeleteWorkflows(e.target.checked);
              }}
              style={{ fontSize: "12px", marginBottom: "10px" }}
            >
              Delete Workflows: <span style={{ fontSize: "12px", color: "#797979" }}>uncheck this if you don't want to delete {section === "Environment" ? "all workflows" : "workflow"} associated with this {section.toLowerCase()}.</span>
            </Checkbox>
          </div>}

          {/* impacted services warning */}
          {impactedServices?.length > 0 && <div style={{ marginBottom: "14px", padding: "10px 14px", background: "#fff7e6", border: "1px solid #ffd591", borderRadius: "6px" }}>
            <p style={{ margin: "0 0 8px 0", fontWeight: 600, color: "#d46b08", fontSize: "13px" }}>
              The following services are using this nodegroup. Deleting it may affect their scaling operations:
            </p>
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              {impactedServices.map((svc, idx) => (
                <li key={idx} style={{ fontSize: "13px", color: "#333" }}>
                  <strong>{svc.environment_name}</strong> / {svc.service_name}
                </li>
              ))}
            </ul>
          </div>}

          {/* name form field */}
          <ContentHolder style={{ display: "flex", justifyContent: 'space-between', marginTop: "10px" }}>
            <Form.Item
              name="name"
              className='formCustomCss'
              rules={[
                {
                  required: true,
                  message: data.title !== "Disconnect this account permanently?" ? 'Please enter Name' : "",
                },
                {
                  // Custom validator for special characters
                  validator: (_, value) => {
                    if (value && (data.title !== "Delete Project Service" && data.title !== "Disconnect this account permanently?") && (data.name !== taskName)) {
                      // console.log("resolved...");
                      return Promise.reject(new Error(`${title} name is not correct`));
                    }
                    else if((fromEnvironment || fromWorkflow) && (data.name !== taskName)) {
                      return Promise.reject(new Error("Please enter correct secret name."));
                    }
                    else if((fromEnvironment || fromWorkflow) && (data.name === taskName)) {
                      return Promise.resolve();
                    }
                    else if(data.title === "Disconnect this account permanently?" && value !== "Disconnect") {
                      return Promise.reject(new Error("Please enter Disconnect to proceed."));
                    }
                    // Always return a Promise
                    return Promise.resolve();
                  }
                }
              ]}
              style={{
                width: "100%",
              }}
            >
              <Input
                name="name"
                id="inputFocus"
                value={taskName}
                onChange={handelInputChange}
                placeholder={data.name}
                autoFocus={true}
                onKeyDown={(e) => {
                  console.log("event.key :", e.key);
                  e.key === "Enter" && handleDelete(e);
                  if (e.key === "ArrowRight" && taskName === "" && section !== "CredentialsManagement") {
                    setTaskName(data.name);
                    form.setFieldsValue({
                      name: data.name
                    });
                  }
                }}
                data-testid={title === "Workflow" ? "workflow-delete-modal-name-input" : section === "Service" ? "service-delete-modal-name-input" : "delete-modal-name-input"}
              />
            </Form.Item>

            {title !== "Disconnect this account permanently?" && <Button
              type="danger"
              style={{ marginLeft: "10px" }}
              onClick={handleDelete}
              data-testid={title === "Workflow" ? "workflow-delete-modal-destroy-button" : section === "Service" ? "service-delete-modal-delete-button" : "delete-modal-destroy-button"}
            >
              {title === "Remove this cluster from Atmosly?" ? "Remove" : (section === "CredentialsManagement" || title === "DATA SOURCE" || title === "APPLICATION" || title === "Delete Role" || title === "Delete Cluster Details" || title === 'Detete the Atmosly created resources permanently?' || title === "RBAC Role"|| title === "Nodegroup" || title === "Nodepool" || title === "Workspace" || title === "Workspace Resources" || data.type === "helm" || section === "Environment" || section === "Service" || section === "Project") ? "Delete" : "Destroy"}
            </Button>}
          </ContentHolder>
          {subTitle3 && <p className="isoWarningText">
            <span>{subTitle3}</span>
          </p>}
        </Box>}
      </Form>

      {data.title === "Delete Project Service" && <Box
        title={title}
        subtitle={subTitle}
        style={{ border: "0", paddingTop: "0" }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            style={{ marginTop: "20px", marginRight: "10px" }}
            onClick={() => {
              setOpenModel({
                modalType: '',
                modalProps: {
                  data: null,
                  columnId: null,
                },
              });
            }}
          >
            Cancel
          </Button>
          <Button
            type="danger"
            style={{ marginTop: "20px" }}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </div>
      </Box>}
      
      {<div style={{display: "flex", justifyContent: "flex-end"}}>
          {(fromEnvironment || fromWorkflow) && title === "Disconnect this account permanently?" && <Button
            type="normal"
            style={{ marginLeft: "10px" }}
            onClick={() => {
              setShowDeleteDetails(false);
            }}
          >
            Cancel
          </Button>}
          {title === "Disconnect this account permanently?" && <Button
            type="danger"
            style={{ marginLeft: "10px" }}
            onClick={handleDelete}
          >
            Disconnect
          </Button>}
      </div>}
    </>
  )
}
